var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row flex-grow" }, [
    _c("div", { staticClass: "col-lg-4 mx-auto" }, [
      _c("div", { staticClass: "auth-form-light text-left p-5" }, [
        _c("div", { staticClass: "brand-logo" }, [
          _c("img", {
            attrs: {
              src: "/media/aform-logo-green.png",
              alt: "Coachingclub.lu"
            }
          })
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v(_vm._s(_vm.$t("pages.forgot_password.reset.title")))]),
        _vm._v(" "),
        _c("h6", {
          staticClass: "font-weight-light",
          domProps: {
            innerHTML: _vm._s(_vm.$t("pages.forgot_password.reset.subtitle"))
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "pt-3" }, [
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password,
                    expression: "password"
                  }
                ],
                staticClass: "form-control form-control-lg",
                class: { "is-invalid": _vm.$errors.has("password") },
                attrs: {
                  type: "password",
                  placeholder: _vm.$t("pages.forgot_password.reset.password")
                },
                domProps: { value: _vm.password },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.resetPassword($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.password = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("error", { attrs: { input: "password" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group mt-4" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password_confirmation,
                    expression: "password_confirmation"
                  }
                ],
                staticClass: "form-control form-control-lg",
                class: {
                  "is-invalid": _vm.$errors.has("password_confirmation")
                },
                attrs: {
                  type: "password",
                  placeholder: _vm.$t(
                    "pages.forgot_password.reset.password_confirm"
                  )
                },
                domProps: { value: _vm.password_confirmation },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.resetPassword($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.password_confirmation = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("error", { attrs: { input: "password_confirmation" } })
            ],
            1
          ),
          _vm._v(" "),
          _vm.password.length < 8 && _vm.password.length > 1
            ? _c("div", { staticClass: "mt3 text-danger mt-1 mb-1" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t("pages.forgot_password.reset.password_length")
                    ) +
                    "\n                "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.password !== _vm.password_confirmation &&
          _vm.password_confirmation.length > 1
            ? _c("div", { staticClass: "mt3 text-danger mt-1 mb-1" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t("pages.forgot_password.reset.password_match")
                    ) +
                    "\n                "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "mt-3" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-block btn-outline-dark btn-lg font-weight-medium auth-form-btn",
                class: { disabled: !_vm.buttonEnabled },
                attrs: { disabled: !_vm.buttonEnabled },
                on: { click: _vm.resetPassword }
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.$t("pages.forgot_password.reset.change_password")
                    ) +
                    "\n                    "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "my-2 d-flex justify-content-between align-items-center"
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "auth-link text-black",
                  attrs: { to: { name: "login" } }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("pages.forgot_password.login")) +
                      "\n                    "
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }